export const USER_ACTION_TYPES = {
  SET_CURRENT_USER: "user/[CURRENT_USER] set",
};
